import "./NoCacheView.scss";

import React from "react";
import { Button } from "react-bootstrap";
import { Link } from "react-router-dom";

import { CopyCodeTabs } from "../../../../components/CopyCodeTabs";
import { RocketIcon } from "../../../../components/icons";

const NoCacheView: React.FC = () => {
  return (
    <div className="quick-start-container">
      <div className="d-flex flex-column align-items-center no-cache-view-column mx-4">
        <RocketIcon />
        <p className="fs-5 text-center">
          You are minutes away from cost effective <br /> light-speed inference
        </p>
        <div className="dimension-wrap ">
          {/* eslint-disable-next-line */}
          <iframe
            width="560"
            height="315"
            src="https://www.youtube.com/embed/iA0f8QPjlk0?si=8Z67PnMcVMvPQRhX"
            title="YouTube video player"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerPolicy="strict-origin-when-cross-origin"
            allowFullScreen
          />
        </div>
        <Button
          target="_blank"
          rel="noreferrer noopener"
          href="https://cogcache.readme.io/reference/quick-start"
        >
          <RocketIcon size={16} />
          Quickstart guide
        </Button>
      </div>
      <div className="d-flex flex-column align-items-center no-cache-view-column mx-4">
        <CopyCodeTabs />
      </div>
    </div>
  );
};

export { NoCacheView };
